<template>
  <div class="downloads" id="downloads">
    <!--
    <transition name="fade">
      <info-modal :dismissInSec="30" v-if="ui.registerSuccess && ui.showRegisterSuccessModal" @close="ui.showRegisterSuccessModal = false">
        <template v-slot:title>
          Schauen Sie bitte in Ihr E-Mail-Postfach!
        </template>
        <template v-slot:text>
          In Kürze erhalten Sie eine Mail mit Ihrem persönlichen Link an die von Ihnen angegebene E-Mail-Adresse! Sollten Sie innerhalb der nächsten 30 Minuten keine Mail von uns erhalten überprüfen Sie bitte Ihre E-Mail-Adresse und Ihren Spam-Ordner.
        </template>
        <template v-slot:footer>
          Kennen Sie schon die neue ERGO BU? Die lohnt sich für Sie und Ihre jungen Kunden!
        </template>
      </info-modal>
    </transition>
    -->
    <!-- <div class="grid-container nopadding"> -->
      <transition name="fade">
        <videoModal v-if="ui.showVidModal" @close="ui.showVidModal = false" :video="model.video">

        </videoModal>
      </transition>
      <div v-if="$store.compShowByDate" class="section-1 bg-darkgreen">
        <div class="grid-x">
          <div class="cell large-offset-1 small-12 large-10 relative">
            <div class="grid-x">
              <div class="cell large-offset-2 small-12 large-8 relative">
                <img v-if="!$store.compIsLoggedIn" class="icon" src="@/assets/icons/closed.svg" />
                <img v-else class="icon" src="@/assets/icons/open.svg" />
                <h2>Download Center</h2>
                <div v-if="!$store.compIsLoggedIn">
                  <p class="info-text">Dieser Bereich wird automatisch freigeschaltet, wenn Sie Ihre eigene App-Version erstellen. Oder Sie registrieren sich hier kurz und einfach mit Ihrer E-Mail-Adresse:</p>
                  <div v-if="!ui.registerSuccess">
                    <div class="input-wrapper">
                      <input class="text-input" v-model="form.email" placeholder="Bitte E-Mail-Adresse eingeben">
                    </div>
                    <div class="centered m-3">
                      <div class="btn big-red link" @click="handleClickOnAnsehenBtn()"><span>Downloads sofort freischalten</span></div>
                    </div>
                    <div class="text-center">
                      <login-link>
                        Bereits registriert?
                      </login-link>
                    </div>
                  </div>
                  <div v-else>
                    <div class="mt-50">
                      <h3>Die Registrierungs-Mail wurde an Sie verschickt!</h3>
                    </div>
                  </div>
                </div>
              </div>

              <transition name="fade">
                <div class="grid-x mt-20" v-if="ui.extendedFormVisible && !ui.registerSuccess" id="downloadregisterform">
                  <div class="cell small-12 large-12 relative">
                    <div class="form-wrapper">
                      <div class="grid-container fluid">
                        <div class="grid-x">
                          <div class="cell large-offset-2 small-12 large-8 relative">
                            <h3>Herzlich Willkommen</h3>
                            <p class="info-text mt-10">Unsere Unterlagen sind exklusiv für Versicherungsvermittler reserviert. Um das Download-Center für Sie freizuschalten, benötigen wir nur noch wenige Infos von Ihnen:</p>
                          </div>
                        </div>

                        <!-- radio-buttons -->
                        <div class="grid-x negative-margin">
                          <div class="cell large-offset-3 small-6 large-3 relative radio-wrapper">
                            <input type="radio" v-model="form.salutation" id="dlMale" name="gender" value="Herr">
                            <label for="dlMale">Herr</label>
                          </div>
                          <div class="cell small-6 large-3 relative radio-wrapper">
                            <input type="radio" v-model="form.salutation" id="dlFemale" name="gender" value="Frau">
                            <label for="dlFemale">Frau</label>
                          </div>
                        </div>

                        <div class="grid-x">
                          <div class="cell large-offset-2 small-12 large-8 relative">
                            <div class="input-wrapper required">
                              <input class="text-input" v-model="form.forename" placeholder="Vorname">
                            </div>
                            <div class="input-wrapper required">
                              <input class="text-input" v-model="form.name" placeholder="Nachname">
                            </div>
                            <div class="input-wrapper">
                              <input class="text-input" v-model="form.companyName" placeholder="Firmenname">
                            </div>

                          </div>

                        </div>


                        <div class="grid-x">
                          <div class="cell large-offset-3 small-12 large-6 relative">
                            <h3>Bitte überprüfen und bestätigen Sie Ihre E-Mail-Adresse:</h3>
                          </div>
                        </div>
                        
                        <!-- Kontaktdaten -->
                        <div class="grid-x">
                          <div class="cell large-offset-2 small-12 large-8 relative">
                            <div class="input-wrapper required">
                              <input class="text-input" v-model="form.email" placeholder="Ihre E-Mail-Adresse" @blur="$v.form.email.$touch()">
                              <div v-if="$v.form.email.$dirty && $v.form.email.$invalid" class="input-error">E-Mail Adresse ungültig</div>
                            </div>
                            <div class="input-wrapper required">
                              <input class="text-input" v-model="form.emailConfirm" placeholder="Ihre E-Mail-Adresse (Wiederholung)" @blur="$v.form.emailConfirm.$touch()">
                              <div v-if="$v.form.emailConfirm.$dirty && $v.form.emailConfirm.$invalid" class="input-error">E-Mail-Adressen stimmen nicht überein</div>
                            </div>
                          </div>
                        </div>

                        <!-- radiobuttons -->
                        <div class="grid-x">
                          <div class="cell large-offset-2 small-12 large-8 relative">
                            <input type="checkbox" v-model="form.acceptContact" id="dlAcceptContact" name="kontaktaufnahme" :value="true">
                            <label for="dlAcceptContact">Ich erlaube ERGO die Kontaktaufnahme mit mir.</label>
                            <input type="checkbox" v-model="terms.acceptPrivacy" id="dlAcceptDatenschutz" name="datenschutz" :value="true">
                            <label for="dlAcceptDatenschutz">Ich akzeptiere die <router-link to="datenschutz" target="_blank">Datenschutzbestimmungen</router-link> und willige in die Verarbeitung meiner Daten zur Kontaktaufnahme und Freischaltung der Downloads ein.</label>
                            <div v-if="ui.clickedOnSendBtn && !form.acceptContact">
                              <p style="font-weight:bold" class="mt-20">
                                Dürfen wir Sie auch künftig mit unseren Angeboten und Vertriebsservices kontaktieren?
                              </p>
                              <!-- radio-buttons -->
                              <div class="grid-x mt-15 mb-40">
                                <div class="cell small-6 large-3 relative radio-wrapper">
                                  <input v-model="form.acceptContact" id="accepptYes" type="radio" :value="true">
                                  <label for="accepptYes">Ja</label>
                                </div>
                                <div class="cell small-6 large-3 relative radio-wrapper">
                                  <input v-model="form.acceptContact" id="accepptNo" type="radio" :value="false">
                                  <label for="accepptNo">Nein</label>
                                </div>
                              </div>
                            </div>

                            <p>Bitte beachten Sie: dieser Service richtet sich exklusiv an Versicherungsvermittler.</p>
                            <p v-if="$v.form.$invalid" class="error-msg">Bitte füllen Sie das Formular aus.</p>
                            <p v-if="$v.terms.$invalid" class="error-msg">Bitte akzeptieren Sie noch die o.g. Bedingungen.</p>
                          </div>
                        </div>

                        <div class="grid-x">
                          <div class="cell large-offset-3 small-12 large-6 relative">
                            <div class="centered mt-2">
                              <div v-if="!ui.registerInProgress" id="btnCreateApp2" class="btn big-red link" :class="{'btn-disabled': compRegisterBtnDisabled}" @click="register()"><span>Freischalt-Link anfordern</span></div>
                              <spinner v-else :size="'medium'"></spinner>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
              
            </div>
          </div>
        </div>
      </div>
      <div v-if="$store.compShowByDate" class="section-2 bg-lightgreen">
        <div class="grid-x">
          <div class="cell small-12 large-12 relative">

            <div class="grid-x grid-margin-x grid-padding-x grid-margin-y">
              <div class="cell small-12 large-offset-1 large-5 relative download-wrapper">
                <div class="grid-x download-wrapper-white" style="height:100%">
                  <div class="cell small-12 text-center">
                    <h3>Produktbroschüre</h3>
                    <p>ERGO BU</p>
                    <img class="img-shadow img" src="@/assets/200528_ERG-19-2829_Broschuere_SBU_210x297_RZ-2.jpg" />
                  </div>
                  <div class="cell small-12 align-self-bottom">
                    <div class="centered mb-5">
                      <div v-if="!$store.compIsLoggedIn" class="btn big-red link btn-disabled"
                      v-tooltip="{ content: ui.dlText, offset: '20px', classes: ['tooltip'], trigger:'hover click focus', hideOnTargetClick: false }"><span>Download (PDF)</span></div>
                      <a v-else href="static/pdf/Produktbroschuere_ERGO_BU.pdf" download @click="$store.trackingClick('Download_Produktbroschuere_ERGO_BU.pdf');">
                      <div class="btn big-red link"><span>Download (PDF)</span></div></a>
                    </div>
                    <!--div class="centered mb-5">
                      <div class="btn big-red link" :class="{'btn-disabled': !$store.compIsLoggedIn}" @click="order()"
                      v-tooltip="{ disabled: $store.compIsLoggedIn, content: ui.orderText, offset: '20px', classes: ['tooltip'], trigger: !$store.compIsLoggedIn && 'hover click focus', hideOnTargetClick: false }"><span>Bestellen</span></div>
                    </div-->
                  </div>
                </div>
              </div>
              
              <div class="cell small-12 large-5 relative download-wrapper">
                <div class="grid-x download-wrapper-white" style="height:100%">
                  <div class="cell small-12">
                    <h3>Flyer</h3>
                    <p>ERGO BU für Schüler</p>
                    <img class="img-shadow img" src="@/assets/200528_ERG-19-2886_Flyer_SBU_Schueler_RZ.jpg" />
                  </div>
                  <div class="cell small-12 align-self-bottom">
                    <div class="centered mb-5">
                      <div v-if="!$store.compIsLoggedIn" class="btn big-red link btn-disabled"
                      v-tooltip="{ content: ui.dlText, offset: '20px', classes: ['tooltip'], trigger: 'hover click focus', hideOnTargetClick: false }"><span>Download (PDF)</span></div>
                      <a v-else href="static/pdf/Flyer_ERGO_BU_Schueler.pdf" download @click="$store.trackingClick('Download_Flyer_ERGO_BU_Schueler.pdf');">
                      <div class="btn big-red link"><span>Download (PDF)</span></div></a>
                    </div>
                    <!--div class="centered mb-5">
                      <div class="btn big-red link" :class="{'btn-disabled': !$store.compIsLoggedIn}" @click="order()"
                      v-tooltip="{ content: ui.orderText, offset: '20px', classes: ['tooltip'], trigger: !$store.compIsLoggedIn && 'hover click focus', hideOnTargetClick: false }"><span>Bestellen</span></div>
                    </div-->
                  </div>
                </div>
              </div>

              
              <div class="cell small-12 large-offset-1 large-5 relative download-wrapper">
                <div class="grid-x download-wrapper-white" style="height:100%">
                  <div class="cell small-12 text-center">
                    <h3>Flyer</h3>
                    <p>ERGO BU für Azubis und Studenten</p>
                    <img class="img-shadow img" src="@/assets/200528_ERG-19-2885_Flyer_SBU_Berufsstarter_RZ.jpg" />
                  </div>
                  <div class="cell small-12 align-self-bottom">
                    <div class="centered mb-5">
                      <div v-if="!$store.compIsLoggedIn" class="btn big-red link btn-disabled"
                      v-tooltip="{ content: ui.dlText, offset: '20px', classes: ['tooltip'], trigger: 'hover click focus', hideOnTargetClick: false }"><span>Download (PDF)</span></div>
                      <a v-else href="static/pdf/Flyer_ERGO_BU_Azubis_Studenten.pdf" download @click="$store.trackingClick('Download_Flyer_ERGO_BU_Azubis_Studenten.pdf');">
                      <div class="btn big-red link"><span>Download (PDF)</span></div></a>
                    </div>
                    <!--div class="centered mb-5">
                      <div class="btn big-red link" :class="{'btn-disabled': !$store.compIsLoggedIn}" @click="order()"
                      v-tooltip="{ disabled: $store.compIsLoggedIn, content: ui.orderText, offset: '20px', classes: ['tooltip'], trigger: !$store.compIsLoggedIn && 'hover click focus', hideOnTargetClick: false }"><span>Bestellen</span></div>
                    </div-->
                  </div>
                </div>
              </div>

              <div class="cell small-12 large-5 relative download-wrapper">
                <div class="grid-x download-wrapper-white" style="height:100%">
                  <div class="cell small-12 text-center">
                    <h3>Highlightblatt</h3>
                    <p>DANV</p>
                    <img class="img-shadow img" src="@/assets/200616_DANV-Highlightblatt-SBU_Mockup.jpg" />
                  </div>
                  <div class="cell small-12 align-self-bottom">
                    <div class="centered mb-5">
                      <div v-if="!$store.compIsLoggedIn" class="btn big-red link btn-disabled"
                      v-tooltip="{ content: ui.dlText, offset: '20px', classes: ['tooltip'], trigger: 'hover click focus', hideOnTargetClick: false }"><span>Download (PDF)</span></div>
                      <a v-else href="static/pdf/Highlightblatt_ERGO_DANV_BU.pdf" download @click="$store.trackingClick('Download_Highlightblatt_ERGO_DANV_BU.pdf');">
                      <div class="btn big-red link"><span>Download (PDF)</span></div></a>
                    </div>
                    <!--div class="centered mb-5">
                      <div class="btn big-red link" :class="{'btn-disabled': !$store.compIsLoggedIn}" @click="order()"
                      v-tooltip="{ disabled: $store.compIsLoggedIn, content: ui.orderText, offset: '20px', classes: ['tooltip'], trigger: !$store.compIsLoggedIn && 'hover click focus', hideOnTargetClick: false }"><span>Bestellen</span></div>
                    </div-->
                  </div>
                </div>
              </div>

              
              <div class="cell small-12 large-5 large-offset-1 relative download-wrapper">
                <div class="grid-x download-wrapper-white" style="height:100%">
                  <div class="cell small-12 text-center">
                    <h3>Produktpräsentation</h3>
                    <p>ERGO BU für Sie</p>
                    <img class="noheight img-shadow img" src="@/assets/ergo_small.jpg" />
                  </div>
                  <div class="cell small-12 align-self-bottom">
                    <div class="centered mb-5">
                      <a v-if="$store.compIsLoggedIn" href="static/pdf/ERGO_BU_Gesamtpraesentation.pdf" download @click="$store.trackingClick('Download_ERGO_BU_Gesamtpraesentation.pdf');"><div class="btn big-red link"><span>Download (PDF)</span></div></a>
                      <div v-else class="btn big-red link btn-disabled"
                      v-tooltip="{ content: ui.dlText, offset: '20px', classes: ['tooltip'], trigger: 'hover click focus', hideOnTargetClick: false }"><span>Download (PDF)</span></div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="cell small-12 large-5 relative download-wrapper">
                <div class="grid-x download-wrapper-white" style="height:100%">
                  <div class="cell small-12 text-center">
                    <h3>Zielgruppen-Film</h3>
                    <p>ERGO BU für Schüler</p>
                    <div class="position-relative link" @click="viewVideo('YZMEUqYsPmE');">
                      <img class="play-btn noheight" src="@/assets/play_s.png" />
                      <img class="noheight img-shadow img" src="@/assets/bu_schueler_500.jpg" />
                    </div>
                  </div>
                  <div class="cell small-12 align-self-bottom text-center">
                    <div class="inline-block">
                      <div class="centered mb-20">
                        <div class="btn big-red link full-width" :class="{'btn-disabled': !$store.compIsLoggedIn}" @click="viewVideo('YZMEUqYsPmE'); $store.trackingClick('Video_YZMEUqYsPmE');"
                        v-tooltip="{ content: ui.viewText, offset: '20px', classes: ['tooltip'], trigger: !$store.compIsLoggedIn && 'hover click focus', hideOnTargetClick: false }"><span>Ansehen</span></div>
                      </div>
                      <div class="centered mb-5">
                        <div v-if="!$store.compIsLoggedIn" class="btn big-red link full-width" :class="{'btn-disabled': !$store.compIsLoggedIn}"
                        v-tooltip="{ content: ui.dlText, offset: '20px', classes: ['tooltip'], trigger: !$store.compIsLoggedIn && 'hover click focus', hideOnTargetClick: false }"><span>Download (MP4)</span></div>
                        <a v-else href="static/video/ergo_BU_Schueler_final_1080p.mp4" download @click="$store.trackingClick('Download_ergo_BU_Schueler_final_1080p.mp4');"><div class="btn big-red link full-width"><span>Download (MP4)</span></div></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="cell small-12 large-5 large-offset-1 relative download-wrapper">
                <div class="grid-x download-wrapper-white" style="height:100%">
                  <div class="cell small-12 text-center">
                    <h3>Zielgruppen-Film</h3>
                    <p>ERGO BU für Azubis und Studenten</p>
                    <div class="position-relative link" @click="viewVideo('glddvPDUOqE');">
                      <img class="play-btn noheight" src="@/assets/play_s.png" />
                      <img class="noheight img-shadow img" src="@/assets/bu_starter_500.jpg" />
                    </div>
                  </div>
                  <div class="cell small-12 align-self-bottom text-center">
                    <div class="inline-block">
                      <div class="centered mb-20">
                        <div class="btn big-red link full-width" :class="{'btn-disabled': !$store.compIsLoggedIn}" @click="viewVideo('glddvPDUOqE'); $store.trackingClick('Video_glddvPDUOqE');"
                        v-tooltip="{ content: ui.viewText, offset: '20px', classes: ['tooltip'], trigger: !$store.compIsLoggedIn && 'hover click focus', hideOnTargetClick: false }"><span>Ansehen</span></div>
                      </div>
                      <div class="centered mb-5">
                        <div v-if="!$store.compIsLoggedIn" class="btn big-red link full-width" :class="{'btn-disabled': !$store.compIsLoggedIn}"
                        v-tooltip="{ content: ui.dlText, offset: '20px', classes: ['tooltip'], trigger: !$store.compIsLoggedIn && 'hover click focus', hideOnTargetClick: false }"><span>Download (MP4)</span></div>
                        <a v-else href="static/video/ergo_BU_Start_1080p.mp4" download @click="$store.trackingClick('Download_ergo_BU_Start_1080p.mp4');"><div class="btn big-red link full-width"><span>Download (MP4)</span></div></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            

          </div>
          <div class="cell small-12 large-5 relative">

          </div>
        </div>
      </div>
      <div class="section-3 bg-darkgreen" id="marketingcenter">
        <div class="grid-x">
            <div class="cell large-offset-1 small-12 large-10 relative">
              <div class="grid-x align-center">
                <div class="cell small-12 large-8 relative">
                  <img v-if="!$store.compHasCustomApp" class="icon" src="@/assets/icons/closed.svg" />
                  <img v-else class="icon" src="@/assets/icons/open.svg" />
                  <h2>Marketing Center</h2>
                  <div v-if="!$store.compHasCustomApp">
                    <p class="info-text">Dieser Bereich wird automatisch freigeschaltet,<br>wenn Sie Ihre eigene App-Version erstellen.</p>
                    <div class="centered mb-5">
                      <div class="btn big-red link" @click="$scrollTo('#appregister');$store.trackingClick('MC_EigeneAppErstellen');"><span>Jetzt eigene App-Version erstellen</span></div>
                    </div>
                    <div class="mt-45 text-center" @click="$store.trackingClick('MC_LoginLinkAnfordern');">
                      <login-link>
                        Bereits eine App erstellt?
                      </login-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          
        </div>
      </div>
      <div class="section-5 bg-lightgreen grid-container fluid" v-if="$store.compHasCustomApp">
        <div class="grid-container fluid">
          <div class="grid-x grid-margin-y align-center">
            <div class="cell large-5 medium-8 small-12 marketing-card cell-padding text-center">
              <div class="marketing-img text-center">
                <img src="@/assets/share.png" />
              </div>
              <div class="mt-20">
                <h4><strong>Anleitung</strong></h4>
                zum Teilen der App
              </div>
              <div class="text mt-20">
                Erfahren Sie – kompakt und übersichtlich – 
                wie Sie Ihre eigene Version von Thores 
                Change Your Life Challenge per E-Mail und Website verbreiten.
              </div>
              <a href="static/pdf/ERGO_BU_Anleitung_zum_Teilen_der_App.pdf" download @click="$store.trackingClick('MC_DownloadAnleitung');"><div class="btn big-red link mt-30 full-width"><span>Download (PDF)</span></div></a>
            </div>
          </div>
          <div class="grid-x grid-margin-y align-center pt-30">
            <div class="cell large-5 medium-8 small-12 marketing-card text-center">
              <div class="marketing-img text-center">
                <img src="@/assets/fb_post.jpg" class="full-width" />
              </div>
              <div class="cell-padding">
                <div class="mt-20">
                  <h4><strong>Werbe-Post</strong></h4>
                  So teilen Sie Ihre App in Ihrem sozialen Netzwerk
                </div>
                <div class="grid-x grid-padding-x grid-padding-y share-icons align-center mt-10">
                  <div class="cell auto shrink relative sm-icons text-center">
                    <div class="icon facebook">
                      <img src="@/assets/icons/ERGO_Icon_black_Facebook.svg">
                    </div>
                  </div>
                  <div class="cell auto shrink relative sm-icons text-center">
                    <div class="icon whatsapp">
                      <img src="@/assets/icons/ERGO_Icon_black_Whatsapp.svg">
                    </div>
                  </div>
                  <div class="cell auto shrink relative sm-icons text-center">
                    <div class="icon email">
                      <img src="@/assets/icons/ERGO_Icon_black_at_Zeichen.svg">
                    </div>
                  </div>
                  <div class="cell auto shrink relative sm-icons text-center">
                    <div class="icon website">
                      <img src="@/assets/icons/ERGO_Icon_black_Laptop.svg">
                    </div>
                  </div>
                </div>
                <div class="text mt-20">
                  Hier können Sie Ihren persönlichen Link zur App 
                  kopieren und dann teilen. Die sozialen Medien bilden 
                  dabei ganz automatisch das Werbebild und den Text 
                  zur App mit ab. Um junge Menschen (oder deren 
                  Eltern!) neugierig zu machen, brauchen Sie ihnen 
                  lediglich eine kurze Nachricht dazu schreiben. Unseren 
                  Textvorschlag dafür können Sie sich hier in Ihre 
                  Zwischenablage kopieren und dann einfach in
                  Ihren Post einfügen.
                </div>
                <div class="btn big-red link mt-30 full-width" @click="$store.trackingClick('MC_WerbePost_TextKopieren');copyText('Liebe Eltern, wie wärs mit einem Energy-Boost für Ihre Kids? Mein Tipp für Sie zum Teilen und Weiterleiten: Thores Change Your Life-Challenge. Hier zeigt der Moderator Thore Schölermann, wie junge Leute ihren Lifestyle verbessern und damit das eigene „Game Over-Risiko“ senken können. Super gemacht!')"><span>Nachrichtentext kopieren</span></div>
                <div class="btn big-red link mt-20 full-width" @click="$store.trackingClick('MC_WerbePost_LinkKopieren');copyText(state.app.appUrl + 'app/' + state.userData.customApp.slug)"><span>Ihren persönlichen App-Link kopieren</span></div>
              </div>
            </div>
          </div>
          <div class="grid-x grid-margin-y align-center pt-30">
            <div class="cell large-5 medium-8 small-12 marketing-card text-center">
              <div class="marketing-img text-center">
                <img src="/static/img/ERGO-Werbemittel_Instagram_Post_800.jpg" class="full-width" />
              </div>
              <div class="cell-padding">
                <div class="mt-20">
                  <h4><strong>Instagram-Post</strong></h4>
                  So teilen Sie Ihre App auf Instagram
                </div>
                <div class="grid-x grid-padding-x grid-padding-y share-icons align-center mt-10">
                  <div class="cell auto shrink relative sm-icons text-center">
                    <div class="icon isntagram">
                      <img class="instagram-padding" src="@/assets/icons/instagram.svg">
                    </div>
                  </div>
                </div>
                <div class="text mt-20">
                  Hier können Sie das Bild für Ihren persönlichen Post zur App kopieren und dann teilen. Um junge Menschen (oder deren Eltern!) neugierig zu machen, brauchen Sie ihnen lediglich eine kurze Nachricht dazu schreiben. Unseren Textvorschlag dafür können Sie sich hier in Ihre Zwischenablage kopieren und dann einfach in Ihren Post einfügen.
                </div>
                <div class="btn big-red link mt-30 full-width" @click="$store.trackingClick('MC_InstagramPost_TextKopieren');copyText('Liebe Eltern, wie wärs mit einem Energy-Boost für Ihre Kids? Mein Tipp für Sie zum Teilen und Weiterleiten: Thores Change Your Life-Challenge. Hier zeigt der Moderator Thore Schölermann, wie junge Leute ihren Lifestyle verbessern und damit das eigene „Game Over-Risiko“ senken können. Den Link zur Challenge finden Sie in meiner Biografie.')"><span>Nachrichtentext kopieren</span></div>
                <div class="btn big-red link mt-20 full-width" @click="$store.trackingClick('MC_InstagramPost_LinkKopieren');copyText(state.app.appUrl + 'app/' + state.userData.customApp.slug)"><span>Ihren persönlichen App-Link kopieren</span></div>
              </div>
            </div>
          </div>
          <div class="grid-x grid-margin-y align-center pt-30">
            <div class="cell large-5 medium-8 small-12 marketing-card text-center">
              <div class="marketing-img text-center position-relative link" @click="model.video = 'RFmBYFvlfTc'; ui.showVidModal = true; $store.trackingClick('MC_Werbefilm_Abspielen');">
                <img src="@/assets/thore_videobotschaft_b2c.jpg" class="full-width" />
                <img src="@/assets/play_s.png" class="play-btn">
              </div>
              <div class="cell-padding">
                <div class="mt-20">
                  <h4><strong>Werbefilm</strong></h4>
                  „Thores Challenge-Aufruf“
                </div>
                <div class="grid-x grid-padding-x grid-padding-y share-icons align-center mt-10">
                  <div class="cell auto shrink relative sm-icons text-center">
                    <div class="icon facebook">
                      <img src="@/assets/icons/ERGO_Icon_black_Facebook.svg">
                    </div>
                  </div>
                  <div class="cell auto shrink relative sm-icons text-center">
                    <div class="icon isntagram">
                      <img class="instagram-padding" src="@/assets/icons/instagram.svg">
                    </div>
                  </div>
                  <div class="cell auto shrink relative sm-icons text-center">
                    <div class="icon website">
                      <img src="@/assets/icons/ERGO_Icon_black_Laptop.svg">
                    </div>
                  </div>
                </div>
                <div class="text mt-20">
                  Teilen Sie Ihre eigene App – und diesen Werbe-Clip mit 
                  Thore Schölermann, um junge Menschen (oder deren 
                  Eltern) auf die Change Your Life-Challenge 
                  aufmerksam zu machen.
                </div>
                <div class="btn big-red link mt-30 full-width" @click="copyText('https://youtu.be/RFmBYFvlfTc');$store.trackingClick('MC_Werbefilm_LinkKopieren');"><span>Link zum Film kopieren</span></div>
              </div>
            </div>
          </div>
        </div>
        
        
        <div class="grid-x" v-if="1==2">
          <div class="cell large-offset-1 small-12 large-11 relative">
            <div class="grid-x grid-margin-y">
              <div class="cell small-12 large-12 relative">

                <div class="grid-x wrapper">
                  <div class="cell large-offset-1 small-12 large-3 relative image center-margin hide-for-small-only">
                    <img src="@/assets/dummyflyer.png" />
                  </div>
                  <div class="cell large-offset-1 small-12 large-6 relative content">
                    <h3>Informationsflyer</h3>
                    <p>„Reihenweise junge Kunden“</p>
                    <div class="relative image center-margin show-for-small-only">
                      <img src="@/assets/dummyflyer.png" />
                    </div>
                    <p class="info-text">Erfahren Sie – kompakt und übersichtlich – wie Sie Ihre eigene Version von Thores Change Your Life-Challenge in sozialen Medien, per E-Mail und Website verbreiten.</p>
                  </div>
                  <div class="cell large-offset-5 small-12 large-6 btn-cell small-order-2 medium-order-1">
                    <div class="btn big-red"><span>Download (PDF)</span></div>
                  </div>
                </div>
              </div>
              <div class="cell small-12 large-12 relative">
                <div class="grid-x wrapper">
                  <div class="cell large-offset-1 small-12 large-3 relative image hide-for-small-only link" style="position:relative" @click="model.video = 'RFmBYFvlfTc'; ui.showVidModal = true">
                    <img src="@/assets/play_s.png" class="play-btn">
                    <img src="@/assets/thore_videobotschaft_b2c.jpg" />
                  </div>
                  <div class="cell large-offset-1 small-12 large-6 relative content">
                    <h3>Werbefilm</h3>
                    <p>„Thores Challenge-Aufruf“</p>
                    <div class="cell large-offset-1 small-12 large-3 relative image show-for-small-only link" @click="model.video = 'RFmBYFvlfTc'; ui.showVidModal = true">
                      <img src="@/assets/thore_videobotschaft_b2c.jpg" />
                    </div>
                    <p class="info-text">Teilen Sie Ihre eigene App – und diesen Werbe-Clip mit Thore Schölermann, um junge Menschen (oder deren Eltern) auf die Change Your Life-Challenge aufmerksam zu machen.</p>
                    <!--div class="btn big-red"><span>Ansehen</span></div-->
                    
                  </div>
                  <div class="cell large-offset-5 small-12 large-6 btn-cell small-order-2 medium-order-1">
                    <div class="btn big-red link" @click="model.video = 'RFmBYFvlfTc'; ui.showVidModal = true"><span>Ansehen</span></div>
                  </div>
                  <div class="cell large-offset-5 small-12 large-6 small-order-1 medium-order-2">
                    <div class="grid-x grid-padding-x grid-padding-y share-icons">
                      <div class="cell auto shrink relative sm-icons text-center">
                        <div class="icon facebook">
                          <img src="../assets/icons/ERGO_Icon_black_Facebook.svg">
                        </div>
                        <div class="icon-text">Auf Facebook<br>teilen</div>
                      </div>
                      <div class="cell auto shrink relative sm-icons text-center">
                        <div class="icon instagram">
                          <img src="../assets/icons/ERGO_Icon_black_Facebook.svg">
                        </div>
                        <div class="icon-text">Auf Instagram<br>teilen</div>
                      </div>
                      <div class="cell auto shrink relative sm-icons text-center">
                        <div class="icon website">
                          <img src="../assets/icons/ERGO_Icon_black_Laptop.svg">
                        </div>
                        <div class="icon-text">In Website<br>einbetten</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="cell small-12 large-12 relative">
                <div class="grid-x wrapper">
                  <div class="cell large-offset-1 small-12 large-3 relative image hide-for-small-only">
                    <img src="@/assets/dummypost.png" />
                  </div>
                  <div class="cell large-offset-1  small-12 large-6 relative content">
                    <h3>Werbe-Post</h3>
                    <p>„Thores Change Your Life-Challenge“</p>
                    <div class="cell large-offset-1 small-12 large-3 relative image show-for-small-only">
                      <img src="@/assets/dummypost.png" />
                    </div>
                    <p class="info-text">Teilen Sie Ihre eigene App – inkl. aufmerksamkeitsstarken Werbebild, das junge Menschen neugierig macht, die Change Your Life-Challenge auszuprobieren.</p>
                  </div>
                  <div class="cell large-offset-5 small-12 large-6 btn-cell small-order-2 medium-order-1">
                    <div class="btn big-red"><span>Ansehen</span></div>
                  </div>
                  <div class="cell large-offset-5 small-12 large-6 small-order-1 medium-order-2">
                    <div class="grid-x grid-padding-x grid-padding-y share-icons">
                      <div class="cell auto shrink relative sm-icons text-center">
                        <div class="icon facebook">
                          <img src="../assets/icons/ERGO_Icon_black_Facebook.svg">
                        </div>
                        <div class="icon-text">Auf Facebook<br>teilen</div>
                      </div>
                      <div class="cell auto shrink relative sm-icons text-center">
                        <div class="icon isntagram">
                          <img src="../assets/icons/ERGO_Icon_black_Facebook.svg">
                        </div>
                        <div class="icon-text">Auf Instagram<br>teilen</div>
                      </div>
                      <div class="cell auto shrink relative sm-icons text-center">
                        <div class="icon whatsapp">
                          <img src="../assets/icons/ERGO_Icon_black_Whatsapp.svg">
                        </div>
                        <div class="icon-text">In WhatsApp<br>teilen</div>
                      </div>
                      <div class="cell auto shrink relative sm-icons text-center">
                        <div class="icon email">
                          <img src="../assets/icons/ERGO_Icon_black_at_Zeichen.svg">
                        </div>
                        <div class="icon-text">Per Mail<br>versenden</div>
                      </div>
                      <div class="cell auto shrink relative sm-icons text-center">
                        <div class="icon website">
                          <img src="../assets/icons/ERGO_Icon_black_Laptop.svg">
                        </div>
                        <div class="icon-text">In Website<br>einbetten</div>
                      </div>
                    </div>
                  </div>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    <!-- </div> -->
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import infoModal from '@/components/infoModal.vue'
import { required, email, sameAs } from 'vuelidate/lib/validators'
import Spinner from 'vue-simple-spinner'
import loginLink from '@/components/loginLink.vue'
import videoModal from '@/components/youtube_modal.vue'

export default {
  name: 'Downloads',
  components: {
    Spinner, infoModal, loginLink, videoModal 
  },
  data() {
    return {
      state: this.$store.state,
      ui: {
        registerSuccess: false,
        registerInProgress: false,
        clickedOnSendBtn: false,
        extendedFormVisible: false,
        showRegisterSuccessModal: false,
        dlText: 'Um die Downloads freizuschalten, registrieren Sie sich bitte kurz mit Ihrer E-Mail-Adresse.',
        orderText: 'Um Bestellungen durchzuführen, registrieren Sie sich bitte kurz mit Ihrer E-Mail-Adresse.',
        viewText: 'Um die Videos ansehen zu können, registrieren Sie sich bitte kurz mit Ihrer E-Mail-Adresse.',
        showVidModal: false
      },
      form: {
        salutation: 'Herr',
        forename: '',
        name: '',
        companyName: '',
        email: '',
        emailConfirm: '',
        acceptContact: false
      },
      model: {
        video: '' //RFmBYFvlfTc
      },
      terms: {
        acceptPrivacy: false
      }
    }
  },
  computed: {
    compRegisterBtnDisabled() {
      if (this.$v.form.$invalid) return true
      if (this.$v.terms.$invalid) return true
    }
  },
  validations: {
    form: {
      salutation: {
        required
      },
      forename: {
        required
      },
      name: {
        required
      },
      email: {
        required,
        email
      },
      emailConfirm: {
        sameAsPassword: sameAs('email')
      },
    },
    terms: {
      acceptPrivacy: {
        sameAs: sameAs( () => true )
      }
    }
  },
  mounted() {

  },
  methods: {
    async copyText(text) {
      this.$clipboard(text)
      await this.$fire({
        title: "Text kopiert!",
        type: "success",
        timer: 2000
      })
    },
    viewVideo(video) {
      if (this.$store.compIsLoggedIn) {
        this.model.video = video
        this.ui.showVidModal = true
      }
    },
    download(video) {
      if (this.$store.compIsLoggedIn) {
        this.model.video = video
        this.ui.showVidModal = true
      }
    },
    order() {

    },
    async handleClickOnAnsehenBtn() {
      this.ui.extendedFormVisible = 1
      await this.$sleep(600)
      this.$scrollTo('#downloadregisterform')
    },
    async register() {
      if (this.compRegisterBtnDisabled) return false
      if (!this.ui.clickedOnSendBtn && !this.form.acceptContact) {
        this.ui.clickedOnSendBtn = true
        return
      }
      this.ui.registerInProgress = true
      await this.$sleep(500)
      let result
      try {
        result = await this.$store.registerWithoutApp(this.form)
      } catch(err) {
        console.log(err)
        console.log('err', err.response)
        await this.$fire({
          title: "Fehler",
          text: "Entschuldigung, leider ist etwas schiefgelaufen. Folgende Fehlermeldung könnte weiterhelfen: " + err.response.data.message,
          type: "error"
        })
        this.ui.registerInProgress = false
        return
      }
      
      await this.$fire({
        title: "Sie haben Post!",
        text: "Zur Bestätigung Ihrer Kontaktdaten haben wir Ihnen eine E-Mail geschickt. Bitte prüfen Sie auch Ihren Spam-Ordner.",
        type: "success"
      })
      this.ui.registerInProgress = false
      this.ui.registerSuccess = true
      //this.ui.showRegisterSuccessModal = true
      this.state.app.registerWithoutAppSuccess = true
      this.state.app.savedForm = true
      this.$scrollTo('#downloads')
    }
  }
}
</script>

<style lang="stylus" scoped>
.inline-block {
  display:inline-block
}
.section-5 {
  padding-top:7em
  padding-bottom:7em
}
.marketing-card {
  background-color:white
  border-radius:6px
  box-shadow:0 3px 10px 0px rgba(0,0,0,0.3)
  //padding:40px
  &.cell-padding {
    padding:40px
  }
  .cell-padding {
    padding:40px
    padding-top:0px
  }
  h4 {
    margin-bottom:3px
  }
  .text {

  }
  .btn {
    padding: 1.1em 3em!important;
  }
  .sm-icons {
    //margin 2.4em 0
    .icon {
      width 2.5em
      height 2.5em
      margin 0 auto
    }
  }
}
.download-wrapper {
  padding-left:10px
  padding-right:10px
}
.download-wrapper-white {
  padding:30px
  border-radius:6px
  box-shadow:0 3px 10px 0px rgba(0,0,0,0.3)
  background: white
  .noheight {
    height:auto!important
  }
  .img {
    height:360px
    width:auto!important
    margin-top:24px!important
    max-width: 100%!important;
  }
  h3 {
    font-size: 1.5em!important
    margin-bottom:0px
  }
}
.required {
  &:after {
    content: '*'
    color: #8e0038
    font-size: 24px
    position:absolute
    top:-5px
    right:-14px
  }
}
.bg-lightgreen {
  background-color #E3F0E6
}
.bg-darkgreen {
  background-color #B5D5C1
}
.full-width {
  width:100%!important
}
.btn-disabled {
  opacity:0.7
}

.error-msg {
  text-align center
  color #BF1528
}
.play-btn {
  width:auto!important
  position: absolute;
  opacity:0.7
  top: 50%;
  transform: translateY(-50%);
  /* add code below to also center horizontally */
  left:0;
  right:0;
  margin: 0 auto;
  z-index:10
}
.section-1, .section-3 {
  padding 5em

  @media screen and (max-width: 39.9375em) {
    padding 3.3em 1.7em
  }
  
  .icon {
    height 3.57em
    display block
    margin 0 auto 1em
  }

  h2 {
    font-family: 'FedraSerifAPro'
    color #8E0038
    font-size 4em
    font-weight bold
    text-align center
    @media screen and (max-width: 39.9375em) {
      font-size 2.17em
    }
  }

  h3 {
    font-size 2em
    font-weight bold
    text-align center
  }
}

.section-2 {
  padding 10em 2em

  .img-shadow {
    box-shadow:0 3px 4px 1px rgba(0,0,0,0.4)
  }

  @media screen and (max-width: 39.9375em) {
    padding 3em 2em
  }

  .mb-8 {
    margin-bottom 8.5em
    @media screen and (max-width: 39.9375em) {
      margin-bottom: 1em
    }
  }
  
  h3 {
    font-size 2em
    font-weight bold
    text-align center
  }
  p {
    font-size 1.14em
    text-align center
  }
  img {
    display block
    margin 0 auto
    // height 29.4em
    // width auto
    max-width 27.4em
    width:100%
    margin-bottom 4.2em
    @media screen and (max-width: 39.9375em) {
      margin-bottom 2.1em
    }
  }
  

  .same-width {
    padding 0 2em

    .btn {
      width 100%
      margin-bottom 1.4em
      @media screen and (max-width: 39.9375em) {
        margin-bottom 0.6em
      }
    }
  }
}

.section-4 {
  @media screen and (max-width: 39.9375em) {
    padding 1.7em
    padding-bottom:40px
  }

  .wrapper {
    margin 5.35em 0
    @media screen and (max-width: 39.9375em) {
      margin 1em 0
    }

    .content, .center-margin {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      @media screen and (max-width: 39.9375em) {
        align-items: center;
      }
    }

    .image {
      margin-top: 5em;
      @media screen and (max-width: 39.9375em) {
        margin-top:0em
      }
    }

    h3 {
      font-size 2em
      font-weight bold
    }
    p {
      font-size 1.14em
      text-align left
      
      &.info-text {
        padding-right 12em
      }
      @media screen and (max-width: 39.9375em) {
        
        &.info-text {
          padding-right:0px
          padding-top:20px
        }
        text-align: center
      }
    }
    img {
      display block
      margin 0 auto
    }
    .btn-cell {
      text-align:left
      @media screen and (max-width: 39.9375em) {
        margin-top:0em
        text-align:center
      }
    }
    .btn {
      padding: 1.1em 2.57em;
      margin-top 1.4em
      @media screen and (max-width: 39.9375em) {
        margin-top:0
      }
    }
    .share-icons {
      margin-top: 3em
      @media screen and (max-width: 39.9375em) {
        margin-top:0.2em
        margin-bottom:1.4em
      }
    }
    .sm-icons {
      //margin 2.4em 0

      .icon {
        width 3.5em
        height 3.5em
        margin 0 auto
      }
      .icon-text {
        padding-top:9px
        line-height:1.4
      }
    }
  }
}

.m-3 {
  margin 3.14em 0
}

.mt-2 {
  margin-top 2em
}

.form-wrapper {
  margin 5.5em 0 12.3em
  background-color #fff
  border-radius .3em
  //padding 5.3em 1em 8.5em
  padding-top 5.3em
  padding-bottom: 8.5em
  padding-left:10px
  padding-right:10px
  box-shadow: 0 1em 1em .1em rgba(0,0,0,0.5);

  @media screen and (max-width: 39.9375em) {
    margin 0 0 3em
    padding-top 1.5em
    padding-bottom: 3em
  }

  .text-input {
    border .1em solid #807E6F
  }

  .info-text {
    text-align left
  }

  input {
    &::placeholder {
      text-align left
    }
  }
}


.negative-margin {
  margin -1em 0 2em
}

.radio-wrapper {
  display flex
  justify-content center
}

.centered {
  display flex
  justify-content center
  &.mb-5 {
    // margin-bottom 5.5em
  }
}

.btn {
  display inline-block 

  &.big-red {
    background-color #BE1528
    padding 1.1em 6.7em
    text-align center
    border-radius 2em
    box-shadow 0 .3em 1em .3em rgba(0,0,0,0.5)

    @media screen and (max-width: 39.9375em) {
      padding 1.1em 4.5em
    }

    span {
      font-size 1.14em
      color #ffffff
      font-weight bold
    }
  }
}

.info-text {
  text-align center
  margin-bottom 2em
}

.input-wrapper {
  margin-bottom 1.1em
  position:relative
}

input {
  width 100%
  padding 1em 1.4em
  border-radius .35em
  border 0
  font-weight bold

  &::placeholder {
    color #807E6F
    font-weight bold
    text-align center
  }
}
</style>